/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { equal } from '@ember/object/computed';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import {
  SERVER_ERROR,
  CLIENT_ERROR,
  READ_ONLY_ERROR,
  VALIDATION_ERROR,
  EXTERNAL_API_FORBIDDEN_ERROR,
  BEE_SAVE_TIMEOUT_ERROR,
} from 'cio/services/api-errors';

interface CioErrorAlertArgs {
  type:
    | typeof SERVER_ERROR
    | typeof CLIENT_ERROR
    | typeof READ_ONLY_ERROR
    | typeof VALIDATION_ERROR
    | typeof EXTERNAL_API_FORBIDDEN_ERROR;
  messages: string[];
  onClose: () => unknown;
}

export default class CioErrorAlert extends Component<CioErrorAlertArgs> {
  @tracked isOpen = true;
  @tracked isExpanded = false;

  @equal('args.type', SERVER_ERROR) isServerError!: boolean;

  @equal('args.type', CLIENT_ERROR) isClientError!: boolean;

  @equal('args.type', READ_ONLY_ERROR) isReadOnlyError!: boolean;

  @equal('args.type', VALIDATION_ERROR) isValidationError!: boolean;

  @equal('args.type', EXTERNAL_API_FORBIDDEN_ERROR) isExternalAPIForbiddenError!: boolean;

  @equal('args.type', BEE_SAVE_TIMEOUT_ERROR) isBeeSaveTimeoutError!: boolean;

  @action
  resetState() {
    this.isOpen = true;
    this.isExpanded = false;
  }

  @action
  toggleOpen() {
    this.isOpen = !this.isOpen;

    if (!this.isOpen) {
      this.isExpanded = false;
    }
  }

  @action
  toggleDetails() {
    this.isExpanded = !this.isExpanded;
  }
}
